import { Directive } from '@angular/core';

@Directive({
  selector: 'ng-template[cueDeclarativeMapMarkerTemplate], [*cueDeclarativeMapMarkerTemplate]',
})
export class DeclarativeMapMarkerTemplateDirective {}
